export default __webpack_public_path__ + "static/media/gif.b4bde4a2.svg";